import React from 'react';
import Link from './link';
import Asset from './asset';
import styles from './project-single.module.scss';
import theme from '../styles/theme.module.scss';

function ProjectFooter(props) {
  const heightHero = 800;
  const widthHero = 1000;

  return (
    <div className={`${styles.footer}`}>
      {props.credits.length > 0 && (
        <div
          className={`${styles.credits} ${theme.gdcont} ${theme.gmcont} ${theme.pT6} ${theme.pB3}`}>
          <h2
            className={`${theme.h5_founders} ${theme.gds1} ${theme.gde4} ${theme.gmmain} ${theme.mB10}`}>
            Credits
          </h2>
          <div className={`${styles.credits} ${theme.gds6} ${theme.gde12} ${theme.gmmain}`}>
            {props.credits.map(function(row, key) {
              return (
                <div key={key} className={`${styles.creditRow} ${theme.mB8}`}>
                  <h3 className={`${theme.h5_founders} ${theme.mB8}`}>{row.title}</h3>
                  {row.projectCreditColumn.map((column, key) => {
                    return (
                      <dl key={key} className={`${styles.creditColumn}`}>
                        <dt>{column.title}</dt>
                        <dd>{column.body}</dd>
                      </dl>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {props.testimonials.length > 0 && (
        <div className={`${styles.testimonials} ${theme.pT6} ${theme.pB6}`}>
          {props.testimonials.map((node, key) => (
            <div key={key} className={`${styles.quote} ${theme.gdcont} ${theme.gmcont}`}>
              <div className={`${styles.meta} ${theme.gds1} ${theme.gde3} ${theme.gmmain}`}>
                <h2 className={`${styles.title} ${theme.mB10} ${theme.h5_founders}`}>
                  Testimonials
                </h2>
                <h3 className={`${styles.name} ${theme.h5_founders}`}>{node.name}</h3>
                <div className={`${styles.role} ${theme.h5_founders} ${theme.mB8}`}>
                  {node.role}
                </div>
              </div>
              <blockquote
                className={`${styles.quoteText} ${theme.gds6} ${theme.gde12} ${theme.gmmain}`}>
                <p className={theme.h3_tiempos}>“{node.quoteText}”</p>
              </blockquote>
            </div>
          ))}
        </div>
      )}
      {props.projectLink.length == 2 && (
        <div
          className={`${styles.relatedProjects} ${theme.pT6} ${theme.gdcont} ${theme.gmcont} ${theme.pB3}`}>
          <h2 className={`${theme.h5_founders} ${theme.gdmain} ${theme.gmmain} ${theme.mB10}`}>
            View More
          </h2>
          <ul className={`${theme.gdmain} ${theme.fdcont} ${theme.gmmain} ${theme.fmcont}`}>
            {props.projectLink.map((node, key) => (
              <li index={key} className={`${theme.fd6} ${theme.fm2}`}>
                <Link to={`/work/${node.slug.current}`}>
                  <Asset asset={node.thumbnailAsset[0]} height={heightHero} width={widthHero} />

                  <div className={`${theme.project_meta} ${theme.mT11}`}>
                    <h2
                      className={[
                        theme.h5_founders,
                        theme.mB12,
                        theme.pB12,
                        theme.borderBottom,
                      ].join(' ')}>
                      <Link to={`/work/${node.slug.current}`}>{node.title}</Link>
                    </h2>
                    <ul className={styles.project_cat}>
                      {node.tags && (
                        <>
                          {node.tags.map(function(cat, index) {
                            return <li key={index}>{cat.value}</li>;
                          })}
                        </>
                      )}
                      {node.tags.length == 0 && (
                        <>
                          {node.categories.map(function(cat, index) {
                            return <li key={index}>{cat.title}</li>;
                          })}
                        </>
                      )}
                    </ul>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ProjectFooter;
